import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useOnlineStatus } from '../Hooks/useOnlineStatus'
import { useMutationQueue } from '../../offline/useMutationQueue'

const OfflineBanner = () => {
  const isOnline = useOnlineStatus()
  const { pendingCount } = useMutationQueue()

  if (isOnline) return null

  return (
    <div className="w-full flex flex-nowrap items-center justify-center gap-2 px-4 py-2 short:py-1 bg-theme-warning text-theme-primary-contrast text-sm font-medium border-b border-theme-warning-hover animate-slide-in-down shrink-0">
      <FontAwesomeIcon icon={faCircleExclamation} className="shrink-0" />
      <span className="hidden sm:inline">You're offline — edits are queued and will sync when you reconnect</span>
      <span className="sm:hidden">Offline — edits are queued</span>
      {pendingCount > 0 && (
        <span className="ml-1 px-2 py-0.5 rounded-full bg-white/25 text-xs font-bold shrink-0">
          {pendingCount} pending
        </span>
      )}
    </div>
  )
}

export default OfflineBanner
